// Reusable ShimmerBar component
const ShimmerBar = ({ className }: { className?: string }) => (
  <div className={`bg-muted dark:bg-muted-foreground/20 animate-pulse rounded ${className}`} />
);

function SpendingSummaryItemSkeleton() {
  return (
    <div className="flex bg-card p-4 rounded-xl overflow-hidden shadow-sm relative border-[1px] border-border">
      {/* Background Bar Placeholder */}
      <div
        className="absolute inset-y-0 left-0 bg-input/70 rounded-r-xl border-r border-border/50"
        style={{ width: '45%', zIndex: 1 }}
        aria-hidden="true"
      ></div>
      {/* Content Placeholders */}
      <div className="flex w-full justify-between items-end space-x-4" style={{ zIndex: 2 }}>
        <div className="flex-1 min-w-0">
          <ShimmerBar className="w-3/4 h-5" /> {/* Name */}
          <ShimmerBar className="w-1/2 h-7" /> {/* Amount */}
        </div>
        <ShimmerBar className="w-10 h-5" /> {/* Percentage */}
      </div>
    </div>
  );
}

export default SpendingSummaryItemSkeleton; 
